import * as React from "react";
import { IdStyles } from "../../less/IdStyles";
import { ModalButtonClose } from "../generic/common/ModalButtonClose";
import { Icon } from "../generic/icon/Icon";
import { IdIcon } from "../generic/icon/IdIcon";
import { TimerCountdown } from "../generic/timer/TimerCountdown";
export var BalloonOfferDetailsContainer = function (_a) {
    var remainingTime = _a.remainingTime, onClose = _a.onClose, children = _a.children;
    return (React.createElement("div", { className: "farm-events__details-container flex flex--centered" },
        React.createElement("div", { className: IdStyles.BalloonOfferContainerRewards + " flex flex--guts" }, children),
        remainingTime && (React.createElement("div", { className: IdStyles.BalloonTimerBackground + " flex flex--aligned pl__small farm-events__timer-container" },
            React.createElement(Icon, { icon: IdIcon.TimeIcn, styleId: IdStyles.IconSmall }),
            React.createElement(TimerCountdown, { remainingTime: remainingTime, className: IdStyles.TextNormal + " ml__small" }))),
        React.createElement(ModalButtonClose, { onClick: onClose, className: "farm-events__close-button" })));
};



//////////////////
// WEBPACK FOOTER
// ./src/features/balloon/BalloonOfferDetailsContainer.tsx
// module id = 2552
// module chunks = 3